import { useEffect, useState } from "react";
import { getInternalAppStatusEmitter } from "../../config";
import { RedoCheckoutButtonClickedEvent } from "../internal-app-events";

export function useCoverageCheckoutButtonClicked() {
  const [coverageCheckoutButtonClicked, setCoverageCheckoutButtonClicked] =
    useState<boolean>(false);

  useEffect(() => {
    const internalEmitter = getInternalAppStatusEmitter();
    const listener = (event: RedoCheckoutButtonClickedEvent) => {
      if (event.addCoverage) {
        setCoverageCheckoutButtonClicked(true);
      }
    };

    internalEmitter.on("RedoCheckoutButtonClickedEvent", listener);

    return () => {
      internalEmitter.off("RedoCheckoutButtonClickedEvent", listener);
    };
  }, []);

  return {
    coverageCheckoutButtonClicked,
    setCoverageCheckoutButtonClicked,
  };
}
